// extracted by mini-css-extract-plugin
export var arrow = "CopyLinkBanner-module--arrow--2149b";
export var arrowNo = "CopyLinkBanner-module--arrow_no--592c6";
export var arrowYes = "CopyLinkBanner-module--arrow_yes--957bf";
export var contentContainer = "CopyLinkBanner-module--contentContainer--f5571";
export var copyLinkButton = "CopyLinkBanner-module--copyLinkButton--52251";
export var copyLinkContainer = "CopyLinkBanner-module--copyLinkContainer--76b59";
export var copyLinkIcon = "CopyLinkBanner-module--copyLinkIcon--f6dec";
export var copySuccess = "CopyLinkBanner-module--copySuccess--b91ab";
export var flex = "CopyLinkBanner-module--flex--60b91";
export var flex1 = "CopyLinkBanner-module--flex_1--e0985";
export var flexCenter = "CopyLinkBanner-module--flex_center--50e24";
export var flexCenterCol = "CopyLinkBanner-module--flex_center_col--144b0";
export var flexCol = "CopyLinkBanner-module--flex_col--c1a05";
export var flexFixCenterCol = "CopyLinkBanner-module--flex_fix_center_col--d080f";
export var flexFixedCenterCol = "CopyLinkBanner-module--flex_fixed_center_col--c6eca";
export var link = "CopyLinkBanner-module--link--ecacd";
export var rotating = "CopyLinkBanner-module--rotating--cd8c4";